import { render, staticRenderFns } from "./product-wizard-child.vue?vue&type=template&id=924bcb0a&"
import script from "./product-wizard-child.vue?vue&type=script&lang=js&"
export * from "./product-wizard-child.vue?vue&type=script&lang=js&"
import style0 from "./product-wizard-child.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports